
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { AvailableIconSizes, KnowFileExtensions, IconSizes } from 'SharedDir/constants/attachments';
import { OneOf } from 'SharedDir/utils/components';
import { computed, defineComponent, PropType } from 'vue';

const NoneColor = 'gray';
interface HasExtension {
  extension?: string | null;
}

export default defineComponent({
  name: 'AttachmentIcon',
  components: { SIcon },
  props: {
    file: { type: Object as PropType<HasExtension>, required: true },
    signed: { type: Boolean },
    needSign: { type: Boolean },
    size: {
      type: String as PropType<(typeof AvailableIconSizes)[number]>,
      validator: OneOf(AvailableIconSizes),
      default: 'medium',
    },
  },
  setup(props: {
    file: HasExtension;
    signed?: boolean;
    needSign?: boolean;
    size: (typeof AvailableIconSizes)[number];
  }) {
    const iconName = computed(() => {
      const { extension } = props.file;
      if (extension && KnowFileExtensions.includes(extension)) {
        return `custom:files/${extension}`;
      }

      return 'custom:files/unknown';
    });

    const signedIconSize = computed(() => {
      const index = AvailableIconSizes.indexOf(props.size);
      return IconSizes[index];
    });

    return {
      iconName,
      signedIconSize,
    };
  },
});
